import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://3ea24f4dea96c60bee147ff1c4160ae9@o4509159122993152.ingest.de.sentry.io/4509159124893776',
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
